import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter as Router } from 'react-router-dom';
import moment from 'moment-timezone';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import * as Yup from 'yup';

import config from './config';
import CenteredLoader from './components/shared/CenteredLoader';
import cargo from './themes/cargo';
import MainComponent from './MainComponent';

import { FIND_RESERVATION } from './store/actions/damage_report';

function Front() {
  const dispatch = useDispatch();
  const notistackRef = React.createRef();
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  };
  const theme = createMuiTheme(cargo);
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    // -- tmp dev
    // const reservation = JSON.parse(localStorage.getItem('reservation'));

    // dispatch({
    //   type: FIND_RESERVATION,
    //   reservation: reservation
    // });
    // -- tmp dev

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        ref={notistackRef}
        maxSnack={3}
        preventDuplicate
        action={key => (
          <IconButton
            className="alert-delete-button"
            onClick={onClickDismiss(key)}
            aria-label="delete"
          >
            <CloseIcon style={{ fill: 'white' }} />
          </IconButton>
        )}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <div className="App tenant-theme">
          <CssBaseline />
          {isLoading ? (
            <CenteredLoader />
          ) : (
            <Router>
              <MainComponent theme={theme} />
            </Router>
          )}
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default Front;
